module.exports = __webpack_public_path__ + "img/bz.svg";